<template>
  <div>
    <common-dialog
      ref="dialog"
      width="800px"
      show-save-button
      unit="折扣活动"
      edit-title
      id-key="DiscountId"
      :data="data"
      :form-rules="rules"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      :before-save="onBeforeSave"
      :save-func="api.save"
      form-label-width="130px"
      @closed="data.Goods=[]"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="活动名称" prop="DiscountName">
              <el-input v-model="data.DiscountName" placeholder="请输入活动名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="折扣率" prop="Rate">
              <el-input v-model="data.Rate" @input="changeRate" placeholder="请输入折扣率">
                <span slot="append">%</span>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="活动开始时间" prop="StartTime">
              <el-date-picker
                size="mini"
                type="datetime"
                v-model="data.StartTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择开始时间"
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="活动截止时间" prop="EndTime">
              <el-date-picker
                size="mini"
                type="datetime"
                v-model="data.EndTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择截止时间"
                style="width:100%"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="活动说明" prop="Remark">
              <el-input type="textarea" v-model="data.Remark" placeholder="请输入活动说明"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="是否可使用优惠券" prop="UserCoupon">
              <el-radio-group v-model="data.UserCoupon">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态" prop="Status">
              <el-radio-group v-model="data.Status">
                <el-radio :label="1">正常</el-radio>
                <el-radio :label="0">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider>活动商品</el-divider>
        <el-table border :data="Goods" style="width: 100%" size="mini">
          <el-table-column prop="GoodsName" label="商品名称" min-width="120px" />
          <el-table-column label="零售价格" min-width="150px">
            <template slot-scope="{row}">
              <span>价格：{{row.RetailPrice==null?'无':row.RetailPrice}}</span>
              <!-- <br />
              <span>价格2：{{row.RetailPrice2==null?'无':row.RetailPrice2}}</span>-->
            </template>
          </el-table-column>
          <el-table-column prop="DiscountPrice" label="折后价格" min-width="150px">
            <template slot-scope="{row}">
              <span>{{row.DiscountPrice}}</span>
              <!-- <el-input-number size="mini" :min="0" v-model="row.DiscountPrice" /> -->
            </template>
          </el-table-column>
          <el-table-column align="center" fixed="right" width="80px">
            <template slot="header">
              <i class="el-icon-circle-plus-outline add-icon" @click="add"></i>
            </template>
            <template slot-scope="{row,$index}">
              <el-button icon="el-icon-delete" type="text" @click="del(row,$index)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <goods-dialog ref="goodsDialog" in-dialog selectable multiple @select-multiple="setGoods" />
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import goodsDialog from "@/components/basicinfo/goods/archives/listDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    goodsDialog,
  },
  data() {
    return {
      data: {
        DiscountId: 0,
        DiscountName: "", //名称
        Rate: "", //折扣率
        StartTime: null, //开始时间
        EndTime: null, //结束时间
        Remark: "", //备注
        UserCoupon: true, //是否可以使用优惠券
        Status: 1, //状态 - 0:停用 1:正常
        // DiscountGoodsIds: [],
        Goods: [],
      },
      tableDel:[],
      Goods: [],
      api: require("@/api/oper/discount").default,
      dgApi: require("@/api/oper/discountGoods").default,
      rules: {
        DiscountName: [{ required: true, message: "活动名称不能为空" }],
        Rate: [
          { required: true, message: "活动名称不能为空" },
          { validator: this.$commonJs.validateRules.num },
        ],
        StartTime: [{ required: true, message: "开始时间不能为空" }],
        EndTime: [{ required: true, message: "结束时间不能为空" }],
      },
    };
  },
  computed: {},
  methods: {
    onEditOpened(data) {
      this.dgApi.list({ DiscountId: this.data.DiscountId }).then((res) => {
        this.Goods = res.Data;
      });
    },
    add() {
      let ids = this.Goods.map((x) => x.GoodsId);
      this.$refs.goodsDialog.open().then((that) => {
        that.getTree();
        that.getData({ Status: 1, NotIds: ids, PromotionType: 2 });
      });
    },
    changeRate() {
      let rate = this.data.Rate==""?100:this.data.Rate
      this.Goods.forEach((x) => {
        x.DiscountPrice = (rate / 100) * x.RetailPrice;
        if (x.T !== 0) x.T = 1;
      });
    },
    setGoods(data) {
      // let goodsList = [];
      data.forEach((x) => {
        let goods = {
          DiscountGoodsId: 0,
          DiscountId: this.data.DiscountId,
          GoodsId: x.GoodsId,
          GoodsName: x.GoodsName,
          DiscountPrice: 0,
          RetailPrice: x.NewRetailPrice,
          T:0
          // RetailPrice2: x.NewRetailPrice2,
        };
        this.Goods.push(goods);
      });
      // this.Goods=goodsList
      this.changeRate()
      // 
      // this.dgApi.saveList(goodsList).then((res) => { 
      //   if (res.Code == 0) {
      //     this.dgApi.list({ DiscountId: this.data.DiscountId }).then((res) => {
      //       this.Goods = res.Data;
      //     });
      //   } else {
      //     this.$message.error(res.Msg == null ? "" : res.Msg);
      //   }
      // });
    },
       del(row, index) {
      this.$confirm("确认删除该行数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        if (row.T !== 0) {
          row.T = 2;
          this.tableDel.push(row);
        }
        this.Goods.splice(index, 1);
        // this.subTable();
      });
    },
    onBeforeSave() {
      if (this.Goods.length == 0) {
        this.$message.warning("请添加活动商品");
        return false;
      }
      let tb=[]
      this.Goods.forEach(e=>{
        if(e.T===0||e.T===1) {
          tb.push(e)
        }
      })
      this.data.Goods=tb
      this.data.Goods = tb.concat(this.tableDel)
      // this.data.DiscountGoodsIds = this.data.Goods.map(
      //   (x) => x.DiscountGoodsId
      // );
      return true;
    },
    onCreateOpened(){
          this.Goods=[]
          this.tableDel=[]
    },
  },
};
</script>